import React, { FunctionComponent } from "react"

interface iProps {
  collection: string
}

const NoMoreLeft: FunctionComponent<iProps> = ({ collection }) => {
  return (
    <div className="content">
      <div className="grid-wrap">
        <div className="no-data">
          You dont have any {collection} left to create.
        </div>
      </div>
    </div>
  )
}

export default NoMoreLeft
